export const GET_CATEGORIES = 'landing/get_categories'